import { useRef } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Link,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { ArrowBackIosNew, ArrowForwardIos } from '@mui/icons-material';
import govtSubsidies from '../../Image/LandingPage/Blog/govt-subsidies.jpg';
import solarInstallationProcess from '../../Image/LandingPage/Blog/solar-installation-process.jpg';
import solarFinanceReturn from '../../Image/LandingPage/Blog/solar-financial-return.jpg';
import selecting5kwsystem from '../../Image/LandingPage/Blog/selecting-5kw-system.jpg';
const blogs = [
  {
    title: 'Solar subsidies in India 2025',
    poster: govtSubsidies,
    link: 'https://www.vaysolar.com/docs/blog/rooftop-solar-subsidies-india-2025/',
  },
  {
    title: 'Solar installation process in Delhi',
    poster: solarInstallationProcess,
    link: 'https://www.vaysolar.com/docs/blog/rooftop-solar-installation-process-in-new-delhi-step-by-step-guide/',
  },
  {
    title: 'Choose the best 5kW solar system',
    poster: selecting5kwsystem,
    link: 'https://www.vaysolar.com/docs/blog/how-to-choose-the-best-5kw-rooftop-solar-system-in-delhi-ncr---a-scientific-guide/',
  },
  {
    title: 'Why go solar now',
    poster: solarFinanceReturn,
    link: 'https://www.vaysolar.com/docs/blog/why-going-solar-now-makes-financial-sense/',
  },
];

export default function BlogSlider() {
  const theme = useTheme();
  const scrollRef = useRef(null);

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const scroll = (direction) => {
    if (scrollRef.current) {
      const cardWidth =
        window.innerWidth < 600 ? scrollRef.current.offsetWidth * 0.85 : 220;
      const scrollAmount = direction === 'left' ? -cardWidth : cardWidth;

      scrollRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <Box pt={5} pb={5} sx={{ position: 'relative' }}>
      <Typography
        variant='h4'
        sx={{
          mb: 5,
          fontSize: {
            xs: theme.typography.h4.fontSize,
            md: theme.typography.h3.fontSize,
          },
          fontWeight: 'bold',
        }}
      >
        Power modern & ecofriendly lifestyle <br />
        with VaySolar
      </Typography>
      <Box
        ref={scrollRef}
        sx={{
          borderRadius: 2,
          pt: 1,
          display: 'flex',
          overflowX: 'auto',
          scrollBehavior: 'smooth',
          scrollSnapType: 'x mandatory',
          gap: 2,
          pb: 2,
          WebkitOverflowScrolling: 'touch',
          msOverflowStyle: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
          '& > *': {
            scrollSnapAlign: 'start',
          },
        }}
      >
        {blogs.map((blog, index) => (
          <Box
            key={index}
            sx={{
              elevation: 0,
              minWidth: { xs: '85%', sm: 310 },
              borderRadius: 2,
              backgroundColor: '#fff',
              textAlign: 'left',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            }}
          >
            <Link
              href={blog.link}
              target='_blank'
              rel='noopener noreferrer'
              sx={{
                display: 'block',
                '&:hover': {
                  cursor: 'pointer',
                },
              }}
            >
              <Box
                component='img'
                src={blog.poster}
                alt={blog.title}
                sx={{
                  width: '100%',
                  height: 240,
                  objectFit: 'cover',
                  borderRadius: 2,
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.05)',
                  },
                }}
              />
            </Link>
            <Typography variant='h6' sx={{ mt: 3, fontWeight: 600 }}>
              <Link
                href={blog.link}
                target='_blank'
                rel='noopener noreferrer'
                underline='none'
                sx={{
                  color: '#444746',
                  '&:hover': {
                    color: '#000000',
                    textDecoration: 'underline',
                  },
                }}
              >
                {blog.title}
              </Link>
            </Typography>
          </Box>
        ))}
      </Box>

      <IconButton
        onClick={() => scroll('left')}
        sx={{
          position: 'absolute',
          top: '58%',
          left: -20,
          transform: 'translateY(-50%)',
          zIndex: 2,
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          width: 40,
          height: 40,
          borderRadius: '50%',
          boxShadow: 2,
          '&:hover': {
            backgroundColor: '#f5f5f5',
          },
        }}
      >
        <ArrowBackIosNew sx={{ fontSize: 18 }} />
      </IconButton>

      <IconButton
        onClick={() => scroll('right')}
        sx={{
          position: 'absolute',
          top: '58%',
          right: -20,
          transform: 'translateY(-50%)',
          zIndex: 2,
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          width: 40,
          height: 40,
          borderRadius: '50%',
          boxShadow: 2,
          '&:hover': {
            backgroundColor: '#f5f5f5',
          },
        }}
      >
        <ArrowForwardIos sx={{ fontSize: 18 }} />
      </IconButton>
    </Box>
  );
}
